import { useEffect, useState } from "react";
import axios from "axios";
import { Quote, Star } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Testimonials() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/testimonials`)
      .then((r) => setItems(r.data || []))
      .catch(() => setItems([]));
  }, []);

  if (!items.length) return null;

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-24 lg:py-36 px-6 lg:px-10 bg-neutral-950 border-y border-white/10"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16 fade-up">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-red-600" />
              <span className="text-xs uppercase tracking-[0.3em] text-red-600">
                What They Say
              </span>
            </div>
            <h2
              data-testid="testimonials-title"
              className="font-heading uppercase text-4xl sm:text-5xl lg:text-6xl leading-none tracking-tight"
            >
              Voices from <br />
              <span className="text-red-600">The Academy.</span>
            </h2>
          </div>
          <p className="max-w-md text-white/60 leading-relaxed">
            Real words from real parents, players and coaches who've been part
            of our journey.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {items.map((t, idx) => {
            // Make first card span 2 cols on lg for visual rhythm
            const featured = idx === 0;
            return (
              <article
                key={t.id}
                data-testid={`testimonial-card-${t.id}`}
                className={`group relative rounded-2xl border border-white/10 bg-black/40 p-8 lg:p-10 hover:border-red-600/40 transition-all fade-up ${
                  featured ? "lg:col-span-2 lg:row-span-1" : ""
                }`}
                style={{ transitionDelay: `${idx * 80}ms` }}
              >
                <Quote
                  className="absolute top-6 right-6 h-10 w-10 text-red-600/20 group-hover:text-red-600/60 transition-colors"
                  strokeWidth={1.5}
                />
                <div className="flex gap-1 mb-5">
                  {Array.from({ length: t.rating || 5 }).map((_, i) => (
                    <Star
                      key={i}
                      className="h-4 w-4 fill-red-600 text-red-600"
                    />
                  ))}
                </div>
                <p
                  className={`text-white/90 leading-relaxed mb-8 ${
                    featured ? "text-xl lg:text-2xl font-heading" : "text-base"
                  }`}
                >
                  "{t.quote}"
                </p>
                <div className="pt-6 border-t border-white/10">
                  <p className="font-heading uppercase tracking-tight text-lg leading-none text-white">
                    {t.name}
                  </p>
                  <p className="text-[11px] uppercase tracking-[0.2em] text-red-600 mt-2">
                    {t.role}
                  </p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
